import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { CATEGORIES, REGISTER } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

export interface Category {
    name: string;
    ordering: string;
}

const token = getCookie(cookieName.token);

const useCategory = () => {
    const [categoryResponse, setCategoryResponse] = useState<any>();
    const [categoryResult, setCategoryResult] = useState<any>();

    const [getCategoriesResponse, setGetCategoriesResponse] = useState<any>();
    const [getCategoriesResult, setGetCategoriesResult] = useState<any>();

    const [deleteCategoriesResponse, setDeleteCategoriesResponse] = useState<any>();
    const [deleteCategoriesResult, setDeleteCategoriesResult] = useState<any>();

    const [updateCategoriesResponse, setUpdateCategoriesResponse] = useState<any>();
    const [updateCategoriesResult, setUpdateCategoriesResult] = useState<any>();


    const createCategory = (obj: Category) => {
        const ordering= obj.ordering && obj.ordering!==null && obj.ordering!==undefined ? `&ordering=${obj.ordering}` : '';
        const url = `${apiURL}/${CATEGORIES}?name=${obj.name}${ordering}`;
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(url, options, setCategoryResponse, setCategoryResult);
    };

    const getCategory = () => {
        const url = `${apiURL}/${CATEGORIES}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetCategoriesResponse, setGetCategoriesResult);
    };

    const updateCategory = (id:number,name: string) =>{
        const url=`${apiURL}/${CATEGORIES}/${id}?name=${name}`;
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(url, options, setUpdateCategoriesResponse, setUpdateCategoriesResult);
    };

    const deleteCategory = (id: number) => {
        const url = `${apiURL}/${CATEGORIES}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeleteCategoriesResponse, setDeleteCategoriesResult);
    };

    const RESPONSES = {
        categoryResponse,
        getCategoriesResponse,
        deleteCategoriesResponse,
        updateCategoriesResponse,
    };

    const RESULTS = {
        categoryResult,
        getCategoriesResult,
        deleteCategoriesResult,
        updateCategoriesResult,
    };

    const CTAs = {
        createCategory,
        getCategory,
        deleteCategory,
        updateCategory,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useCategory;
